import {IElement} from '../../../incase-domain/elements';
import {ELEMENT} from '../../../incase-domain/elements/base/ElementTypes';
import {getEmptyElement} from '../../element';

function generateImageTemplate(slideId: string): IElement[] {
    return [
        {
            ...getEmptyElement(slideId, ELEMENT.PLACEHOLDER),
            name: 'Image 1',
            fitContent: false,
            yPosition: 5,
            xPosition: 5,
            width: '90%',
            height: '90%',
        },
    ];
}

export default generateImageTemplate;
